<template>
  <div class="userLog-main-content">
    <div class="search">
      <el-form class="searchForm" :model="searchForm">
        <el-form-item>
          <el-input size="small" :min-width="100" v-model="searchForm.keyword" placeholder="输入留言内容、姓名、手机、邮箱....">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="table">
      <el-table stripe size="medium" :data="list" highlight-current-row v-loading="loading" border style="width: 100%;">
        <el-table-column align="center" prop="name" label="用户姓名" min-width="100"></el-table-column>
        <el-table-column align="center" prop="mobile" label="手机" min-width="100"></el-table-column>
        <el-table-column align="center" prop="email" label="邮箱" min-width="100"></el-table-column>
        <el-table-column align="center" prop="country" label="国家" min-width="100"></el-table-column>
        <el-table-column label="留言时间" align="center" min-width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.createDate | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="留言内容" min-width="300"></el-table-column>

        <el-table-column align="center" label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination :params="pageParams" @pageList="pageList"></Pagination>


  </div>
</template>

<script>
import { leave_page, leave_del, user_refresh_token } from "../api/api";
import './../assets/css/userLog.css';
import Pagination from "../components/Pagination";

export default {
  data() {
    return {
      timer: null, // 定时器
      // 页面控制元素
      loading: false, //是否显示加载
      editTitle: '', //编辑页面标题
      editType: 1, // 新增/修改
      editFormVisible: false, // 编辑页面显隐
      // 搜索表单
      searchForm: {
        keyword: ''
      },
      // 分页表单
      pageParams: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      formData: {
        id: '',
        name: '',
        mobile: '',
        country: '',
        email: '',
        message: ''
      },
      list: [],
    };
  },
  // 注册组件
  components: { Pagination },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.page(this.pageParams.currentPage, this.pageParams.pageSize);
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken()
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "userlog", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    // ----------------------search start---------------------
    search() {
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    // 分页插件事件
    pageList(currentPage, pageSize) {
      this.page(currentPage, pageSize);
    },
    // 分页查询
    async page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;
      param.keyword = this.searchForm.keyword;

      const data = await leave_page(param);

      this.pageParams.total = data.data.total;
      this.pageParams.pageSize = data.data.pageSize;
      this.pageParams.currentPage = data.data.currentPage;
      this.list = data.data.list;

      if (this.pageParams.total > 0 && this.pageParams.total == (this.pageParams.currentPage - 1) * this.pageParams.pageSize) {
        this.page(this.pageParams.currentPage - 1, this.pageParams.pageSize);
      } else {
        this.list = data.data.list;
      }
    },

    // ----------------------search end---------------------



    // ----------------------delete start-------------------
    // 删除记录
    handleDelete(index, id) {
      this.delConfirm(index, id);
    },
    //删除确认对话框
    delConfirm(index, id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          leave_del(id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.list.splice(index, 1);
              this.page(this.pageParams.currentPage, this.pageParams.pageSize);
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------delete end---------------------
  }
};
</script>
<style scoped>
.el-image {
  width: 80px;
  height: 80px;
}
</style>





// WEBPACK FOOTER //
// src/views/Leaveword.vue